exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-6d527572]{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));--tw-border-opacity:1;border-color:rgba(221,221,221,var(--tw-border-opacity));border-radius:.25rem;border-width:1px;overflow:hidden;position:absolute;--tw-shadow:0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);top:calc(100% + 5px);right:-5px;min-width:10rem}", ""]);

// exports
